module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/3.1-account-password-link.bfdf5e67.png";